import { BIEvent } from '../helpers/bi/event-type';
import { Logger, withLogger } from '../helpers/bi';
import * as React from 'react';
import { ANSWERS_BASE_DOMAIN } from '../helpers/utils';
import { CreateAccount } from './create-account/comp';
import { Icon } from '@wix/answers-ui-libby';
import { iconsMap } from './icons/icons';
import { ForgotDomain } from './forgot-domain/comp';
import { LoginTenant } from './login-tenant/comp';
import { WixSsoError } from './wix-sso-error';
import { SPECIAL_MARKETING_SIGNUP_PATH, TECH_ASSESSMENT_PATH, withTranslator } from '../helpers/shared';
import { SpecialCreateAccount } from './special-create-account';
import { TechAssessment } from './tech-assessment';

export enum AccountState {
	SIGNUP,
	SPECIAL_SIGNUP,
	SIGNUP_POST,
	SIGNUP_WIX_POST,
	LOGIN,
	FORGOT,
	SIGNUP_WIX_ERROR,
	TECH_ASSESSMENT
}

export const getAccountState = () => {
	try {
		const isSpecialSignup = location.pathname.includes(SPECIAL_MARKETING_SIGNUP_PATH);
		const isTechAssessment = location.pathname.includes(TECH_ASSESSMENT_PATH);
		const initState = location.pathname.match(
			/login|signup\/wix\/post|signup\/wix\/error|signup|forgot/
		);

		if (isSpecialSignup) {
			return AccountState.SPECIAL_SIGNUP;
		} else if (isTechAssessment) {
			return AccountState.TECH_ASSESSMENT;
		} else {
			return initState && initState[0]
			? AccountState[initState[0].toUpperCase().replace(/\//g, '_') as any]
			: AccountState.SIGNUP;
		}
	} catch (e) {
		return null;
	}
};

export class Account extends React.PureComponent<
	withLogger & withTranslator,
	any
> {
	logger: Logger = this.props.logger;

	state = {
		visibleState: getAccountState() || AccountState.SIGNUP
	};

	componentDidMount () {
		this.logger.logEvent(BIEvent.PAGE_VIEW, { page_url: location.href });
	}

	onSignup = (subdomain: string, email: string, token: string | null, trafficSource?: string) => {
		setTimeout(() => {
			const tsrc = trafficSource ? `&tsrc=${trafficSource}` : '';
			const encodedRedirectUrl = encodeURIComponent(
				`https://${subdomain}${ANSWERS_BASE_DOMAIN}/app/onboarding?firstUse=true${tsrc}`
			);
			const redirectUrlQS = `redirectUrl=${encodedRedirectUrl}`;

			if (token) {
				const path = `//${subdomain}${ANSWERS_BASE_DOMAIN}/account/agents/signin/owner/${token}?${redirectUrlQS}`;
				location.replace(path);
			} else {
				const path = `//${subdomain}${ANSWERS_BASE_DOMAIN}/account/agents/signin?email=${email}`;
				location.replace(path);
			}
		}, 300);
	}

	renderSignup = (isWixSignup: boolean = false) => (
		<CreateAccount
			onSignup={this.onSignup}
			logger={this.logger}
			isWix={isWixSignup}
			t={this.props.t}
		/>
	)

	renderSpecialSignup = () => (
		<SpecialCreateAccount
			onFinishSignup={this.onSignup}
			logger={this.logger}
			t={this.props.t}
		/>
	)

	renderLogin = () => <LoginTenant logger={this.logger} t={this.props.t} />;

	renderForgotDomain = () => <ForgotDomain t={this.props.t} />;

	renderWixSsoError = () => <WixSsoError t={this.props.t} />;

	renderTechAssessment = () => <TechAssessment />;

	renderMain = () => {
		switch (this.state.visibleState) {
			default:
				return this.renderSignup();
			case AccountState.SPECIAL_SIGNUP:
				return this.renderSpecialSignup();
			case AccountState.SIGNUP_WIX_POST:
				return this.renderSignup(true);
			case AccountState.LOGIN:
				return this.renderLogin();
			case AccountState.FORGOT:
				return this.renderForgotDomain();
			case AccountState.SIGNUP_WIX_ERROR:
				return this.renderWixSsoError();
			case AccountState.TECH_ASSESSMENT:
				return this.renderTechAssessment();
		}
	}

	render () {
		const isTechAssessment = this.state.visibleState === AccountState.TECH_ASSESSMENT;
		const isSpecialSignup = this.state.visibleState === AccountState.SPECIAL_SIGNUP;
		const mainView = this.renderMain();

		if (isTechAssessment) {
			return (
				<div className='app'>
					<div className='assessment-container'>{mainView}</div>
				</div>
			);
		}

		if (isSpecialSignup) {
			return (
				<div className='app special-signup-app'>
					<div className='special-signup'>{mainView}</div>
				</div>
			);
		}

		return (
			<div className='app'>
				<a className='logo-link' href='/'>
					<Icon className='logo' icon={iconsMap.wixLogo} />
				</a>
				<div className='wrapper'>{mainView}</div>
			</div>
		);
	}
}
